// extracted by mini-css-extract-plugin
module.exports =  {"menuIconLink":"header__npT_XYxfCNDJJe8MTj5V"};